// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__17rAi","consentsList":"PatientConsents_consentsList__3-J5G","consentsListEmpty":"PatientConsents_consentsListEmpty__3D_K7"};